import React, { useContext, useEffect, useState } from 'react';
import Tableclients from '../../components/tableClients';
import { Grid } from '@mui/material';
import TitlePages from '../../components/generic/titlePages';
import CardSys from '../../components/cardSys';
import SubTitlePages from '../../components/generic/subTitlePages';
import { api } from '../../services/api';
import ModalSys from '../../components/modal';
import FilterTableSys from '../../components/filterTableSys';
import ClientModules from '../../components/clientModules';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import LogoClients from '../../components/logoClients';
import { GlobalAlertContext } from '../../contexts/GlobalAlertContext';
import ButtonCreate from "../../components/buttonCreate";

export default function Clients() {

  const [modal, setModal] = useState({ visible: false, enterprise: null });
  const [modalEdit, setModalEdit] = useState({ visible: false, enterprise: null });

  const [clients, setClients] = useState([]);
  const [clientsView, setClientsView] = useState([]);
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);


  const navigate = useNavigate();
  const { user } = useContext(AuthContext)

  useEffect(() => {
    if (user?.id) {
      console.log(user);
      if (user?.id_client !== 25886008) {
        navigate("/notpermission")
      }
    }
  }, [user, navigate])

  useEffect(() => {
    getClients();
  }, []);

  async function getClients() {
    handleLoading(true);
    try {
      const { data: clients } = await api({ method: "GET", url: "/source/client" });
      setClients(clients);
      setClientsView(clients);
      localStorage.setItem("PreviewPDFClient", JSON.stringify(clients));
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
  }

  const handleFilter = (value) => {
    if (value == "") {
      setClientsView(clients)
    } else {
      const listView = []
      clients.map(el => {
        const items = Object.values(el)
        const compare = []
        items.map(item => {
          if (item) {
            compare.push(item.toString())
          }
        })
        if (!!compare.find(item => item.toUpperCase().includes(value.toUpperCase()))) {
          listView.push(el)
        }
      })
      setClientsView(listView)
    }
  }

  return (
    <>
      <Grid container sx={{ marginBottom: "16px" }}>
        <Grid item xs={12}>
          <TitlePages>Clientes</TitlePages>
        </Grid>
        <Grid item xs={12}>
          <SubTitlePages>{clients.length} cadastros</SubTitlePages>
        </Grid>
      </Grid>
      <Grid container sx={{ marginBottom: "16px" }}>
        <Grid item xs={12}>
          <FilterTableSys handleFilter={value => handleFilter(value)}>
          </FilterTableSys>
        </Grid>
      </Grid>
      <CardSys>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            item
            xs={12}
            justifyContent="center"
            alignItems="center"
          >
            <Tableclients handleUsers={(value) => setModal({ visible: true, enterprise: value })} clients={clientsView} handleLogo={(value) => setModalEdit({ visible: true, enterprise: value })}></Tableclients>
          </Grid>
        </Grid>
      </CardSys>
      {
        modal.visible ?
          <ModalSys open={modal.visible} handleClose={() => setModal({ visible: false })}>
            <ClientModules client={true} handleClose={() => setModal({ visible: false })} id={modal?.enterprise?.cre_id} title={modal?.enterprise?.razao_social}></ClientModules >
          </ModalSys>
          : null
      }

      {
        modalEdit.visible ?
          <ModalSys open={modalEdit.visible} handleClose={() => setModalEdit({ visible: false })}>
            <LogoClients updateTable={() => getClients()} logo={modalEdit?.enterprise?.logos} logoImg={modalEdit?.enterprise?.logo_img} id={modalEdit?.enterprise?.cre_id} title={modalEdit?.enterprise?.razao_social} handleClose={() => setModalEdit({ visible: false })} ></LogoClients>
          </ModalSys>
          : null
      }
    </>
  )
}
